import { Flex, Text } from "@fluentui/react-northstar";
import React from "react";
import AnnotationSystem from "../AnnotationSystem";
import { useIntelligentGrading } from "../../../../../../context/useIntelligentGrading";

const TextResponse = ({ text, isAnnotationMode }) => {
  const { annotations, setAnnotations } = useIntelligentGrading();
  const index = annotations.findIndex(
    (annotation) => annotation.id === text.id
  );

  const onAnnotationAdd = (annotation) => {
    let clonedAnnotations = [...annotations];
    clonedAnnotations[index].annotations.push(annotation);
    setAnnotations(clonedAnnotations);
  };

  const onAnnotationDelete = (id) => {
    let clonedAnnotations = [...annotations];
    clonedAnnotations[index].annotations = clonedAnnotations[
      index
    ].annotations.filter((annotation) => annotation.id !== id);
    setAnnotations(clonedAnnotations);
  };
  const onAnnotationEdit = (id, comment) => {
    let clonedAnnotations = [...annotations];
    clonedAnnotations[index].annotations = clonedAnnotations[
      index
    ].annotations.map((annotation) =>
      annotation.id === id ? { ...annotation, comment } : annotation
    );
    setAnnotations(clonedAnnotations);
  };

  return (
    <Flex gap="gap.smaller" column>
      <Text content="Text Response Analysis" weight="semibold" />
      <AnnotationSystem
        isAnnotationMode={isAnnotationMode}
        essayText={text.extractedText}
        annotations={annotations?.[index]?.annotations || []}
        onAnnotationAdd={onAnnotationAdd}
        onAnnotationDelete={onAnnotationDelete}
        onAnnotationEdit={onAnnotationEdit}
      />
    </Flex>
  );
};

export default TextResponse;
